import React from 'react';
import { QuickNodeDialog } from './ui/QuickNodeDialog';
import type { WorkspaceState, WorkspaceCallbacks } from '../utils/workspace.types';

interface WorkspaceDialogsProps {
  state: WorkspaceState;
  callbacks: WorkspaceCallbacks;
  operations: {
    nodes: any;
  };
}

/**
 * Workspace Dialogs component - all modal/dialog components
 * Extracted from STAADWorkspace3D to maintain exact behavior
 */
export const WorkspaceDialogs: React.FC<WorkspaceDialogsProps> = ({
  state,
  callbacks,
  operations
}) => {
  return (
    <>
      {/* Quick Node Creation Dialog */}
      <QuickNodeDialog
        isOpen={state.showQuickNodeDialog}
        coords={state.editableCoords}
        onCoordChange={operations.nodes?.handleCoordChange || ((axis, value) => {
          callbacks.setEditableCoords({
            ...state.editableCoords,
            [axis]: value
          });
        })}
  // csv input removed: coordinateInputValues deprecated
        offsetEnabled={state.quickNodeOffsetEnabled}
        offsetCount={state.quickNodeOffsetCount}
        offsetValues={state.quickNodeOffsetValues}
        onSetOffsetEnabled={(v) => callbacks.setQuickNodeOffsetEnabled && callbacks.setQuickNodeOffsetEnabled(v)}
        onSetOffsetCount={(n) => callbacks.setQuickNodeOffsetCount && callbacks.setQuickNodeOffsetCount(n)}
        onSetOffsetValue={(axis, val) => callbacks.setQuickNodeOffsetValues && callbacks.setQuickNodeOffsetValues({
          x: axis === 'x' ? val : (state.quickNodeOffsetValues?.x ?? 0),
          y: axis === 'y' ? val : (state.quickNodeOffsetValues?.y ?? 0),
          z: axis === 'z' ? val : (state.quickNodeOffsetValues?.z ?? 0)
        })}
        onConfirm={operations.nodes?.handleQuickNodeConfirm || (() => {})}
        onCancel={operations.nodes?.handleQuickNodeCancel || (() => {})}
      />

  {/* Coordinate input modal removed */}
    </>
  );
};
